import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { supportedBrowsers } from './supported-browsers';
import './app/core/extensions/chart.extension';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ConfigurationService } from './app/core/configuration/configuration.service';
import { LOAD_CONFIGURATION_PROVIDER } from './app/core/configuration/configuration.module';
import { provideServiceWorker } from '@angular/service-worker';
import { HTTP_INTERCEPTORS_TOKEN } from './app/core/authentication/authentication.module';
import {
  SHORT_LOCALE_ID_PROVIDER,
  TITLE_STRATEGY_PROVIDER,
  PAGE_KEY_PROVIDER,
} from './app/core/shared/initialize.provider';
import { migrateLegacyStorage } from './app/legacy-storage-migration';

registerLocaleData(localeFr);
migrateLegacyStorage();

if (!supportedBrowsers.test(navigator.userAgent)) {
  // eslint-disable-next-line no-console
  console.error('Your browser is not supported.');
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    LOAD_CONFIGURATION_PROVIDER,
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production, // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    HTTP_INTERCEPTORS_TOKEN,
    ConfigurationService,
    SHORT_LOCALE_ID_PROVIDER,
    TITLE_STRATEGY_PROVIDER,
    PAGE_KEY_PROVIDER,
    importProvidersFrom(AppModule),
  ],
})
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
